import { FETCHCATEGORY_SUCCESS, FETCHCATEGORY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const fetchCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCHCATEGORY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case FETCHCATEGORY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default fetchCategoryReducer;



